import React, { useEffect, useState } from 'react';
import { resendOrderEmail } from 'services';
import { showError, showSuccess } from 'utils';
import styles from './index.module.scss';

const ResendEmailModal = props => {
  const [email, setEmail] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const {
    orderId,
    userEmail,
    toggleModal,
    onSuccess,
  } = props;

  useEffect(() => {
    setEmail(userEmail);
  }, []);
  
  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    try {
      await resendOrderEmail({
        id: orderId,
        email: email?.toLowerCase(),
      });
      showSuccess('Email sent successfully');
      onSuccess && onSuccess();
      toggleModal();
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <form onSubmit={handleSubmit} className={styles['main-container']}>
      <div className={styles['modal-container']}>
        <div className={styles['modal-header']}>
          <div>
            <div className={styles['label']}>Order</div>
            <div className={styles['modal-title']}>Resend Email</div>
          </div>
          <i className={'fa fa-times'} onClick={toggleModal} />
        </div>
        <div className={styles['modal-body']}>
          <div>
            <div className={styles['label']}>{`Recipient's Email`}</div>
            <input
              className={'form-control'}
              value={email}
              disabled={loading}
              onChange={e => setEmail(e.target.value)}
            />
          </div>
        </div>
        <div className={styles['modal-footer']}>
          <button
            className={styles['cancel-button']}
            onClick={toggleModal}
            disabled={loading}
            type={'button'}
          >
            Cancel
          </button>
          <button
            type={'submit'}
            className={styles['submit-button']}
            disabled={loading}
          >
            Submit
          </button>
        </div>
      </div>
    </form>
  );
};

export default ResendEmailModal;